import type { FaireProductEntity } from "../../entity_types/product";

export const p_psks2av36s: FaireProductEntity = {
  token: "p_psks2av36s",
  type: "product",
  name: "Moroccan Stemless Goblet - Clear",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/b9511ffca8415049afbc5ea893eaa8ae257f8c404a5c4976e4adf5e45c84983d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a443b3227aa6b1e66aa6e0326a8f1eb10f9e4888afff4a62740b09cd0bb11233.jpeg",
    "https://cdn.faire.com/fastly/22260b67622dcff4679e365f29ae76e277dc86cc4064c0703b29635577e6f150.jpeg",
    "https://cdn.faire.com/fastly/5228618bf9d1be803fa7b7b49af27f2f79e9e53e10c454b0aaad6b87e3577a96.jpeg",
    "https://cdn.faire.com/fastly/81fe4dc779d3ca6a3ba0ddff472c9684165117c3a6c6512d8f9ef2de6bdf26fb.jpeg",
    "https://cdn.faire.com/fastly/47851740c9a55fa2d1c9128143507009f29a6a657c64be5bb584235a8c3547fc.jpeg",
    "https://cdn.faire.com/fastly/62ccfdb07098249610073842a1b1453402383370c9fe94446cfc6c39b08ca517.jpeg",
    "https://cdn.faire.com/fastly/c6a247b7d72e34308eef761510ed43a26706500eef7ff435d1fe4ba5084cade9.jpeg",
    "https://cdn.faire.com/fastly/54e123831911668b646671f39d34b2e57f41142c43d2eb333e3c09306a92b90d.jpeg",
    "https://cdn.faire.com/fastly/a80fc71d5dc9ac6edcc090da0d4d82bf0e5c0a950e90f63ea00fd710f9bcd627.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "**Packaged in sets of 4; 16 single glasses in a case. Price shown is per glass.\n\nWhether you're sipping fine wine, enjoying a cocktail, or serving water at a special dinner, these Moroccan handblown glasses are versatile and complement any occasion.\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and individual character of each piece. \n\nOur skilled artisans meticulously handcraft each glass, ensuring the utmost precision and attention to detail. The result is a one-of-a-kind piece that boasts both quality and uniqueness.\n\nCare - Dishwasher safe, but please note: handblown glass is sensitive to drastic temperature changes.\n\nPackaged in sets of 4 in traditional Moroccan gift packaging.\n\n12 fl oz ",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:24.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
